import React from 'react'
import { observer } from 'mobx-react';
import ProjectStore from '../../../store/projectStore'
import renderField from '../../edit-page/fields/FieldExtensions'
import Card from '../../edit-page/Card';
import _ from 'lodash';

interface SelfProps {
    helpInfo: string,
    canEdit: boolean,
}

const TWSProjectGeneralInformation = observer(
    class TWSProjectGeneralInformation extends React.Component<SelfProps> {

        state = {
            editable: [],
        }

        onButtonEditClick = (field: { slug: any; }) => {
            let newEditable = _.xor(this.state.editable, [field.slug]);
            ProjectStore.generalInformationDuringEdit = newEditable.length > 0;

            this.setState({
                editable: newEditable,
            })
        }

        renderField = (field: { slug: never; }, possibleToEdit = false) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => ProjectStore.setDirty(true));
        }

        render() {
            console.warn('this.props', this.props)
            return (
                <Card
                    helpInfo={this.props.helpInfo}
                    editableMode={this.props.canEdit}
                    label="General information">
                    <div className="row row-no-outer-gutter">
                        <div className="column-6 column-xs-12">
                            {this.renderField(ProjectStore.formModel.generalInformation.name, this.props.canEdit)}
                            {this.renderField(ProjectStore.formModel.generalInformation.number)}
                        </div>
                        <div className="column-6 column-xs-12">
                            {ProjectStore.formModel.generalInformation.responsible.visible && this.renderField(ProjectStore.formModel.generalInformation.responsible, this.props.canEdit)}
                        </div>
                    </div>
                </Card>
            )
        }
    }
)

export default TWSProjectGeneralInformation;